export default {
    commonReducer: {
     showToast:false,
     downloadToast:false
    }
};